// extracted by mini-css-extract-plugin
export default {"categoryHeader":"categoryHeader_categoryHeader__aLMEp","fixedcategoryHeader":"categoryHeader_fixedcategoryHeader__kUGp3"};